<!-- Page Header -->
<header class="bg-white shadow-sm border-b border-gray-200 px-6 py-1">
  <div class="flex items-center justify-between">
    <!-- Left Section -->
    <div class="flex items-center gap-4">
      @if (showHamburger) {
      <button
        (click)="toggleSidebar()"
        class="p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200 cursor-pointer"
      >
        <i class="pi pi-bars text-gray-600 text-xl"></i>
      </button>
      }

      <!-- Greeting -->
      <div>
        <h1
          class="hidden md:inline text-sm sm:text-base md:text-lg lg:text-2xl font-bold text-gray-900"
        >
          {{ greeting }}
        </h1>
      </div>
    </div>

    <!-- Right Section - User Profile -->
    <div class="flex items-center gap-4">
      <!-- Notification Dropdown -->
      <app-notification-dropdown></app-notification-dropdown>
      <!-- <span class="hidden md:inline text-gray-300 mx-2">|</span>
      <i class="pi pi-user" style="color: #708090; font-size: 1.25rem"></i> -->

      <!-- User Profile -->
      <div class="flex items-center gap-3">
        <div class="text-right">
          <p class="text-sm font-medium text-gray-900">
            {{ userProfile.name }}
          </p>
          <p class="text-xs text-gray-500">{{ userProfile.role }}</p>
        </div>

        <!-- Avatar with Menu -->
        <div class="relative">
          <button
            pButton
            type="button"
            class="p-button-text p-button-rounded"
            (click)="menu.toggle($event)"
          >
            <div
              class="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center"
            >
              <span class="text-white font-semibold text-sm">
                {{ userProfile.avatar }}
              </span>
            </div>
            <i class="pi pi-chevron-down text-gray-600 text-sm ml-1"></i>
          </button>

          <p-menu
            #menu
            [popup]="true"
            [model]="userMenuItems"
            appendTo="body"
            styleClass="user-dropdown-menu"
          ></p-menu>
        </div>
      </div>
    </div>
  </div>
</header>
